import { Alert, Button } from "@mui/joy";
import { Typography } from "@mui/material";
// import { useLeagueEntriesTableContext } from "./LeagueEntriesContext";
import { useNavigate } from "@tanstack/react-router";

import { useLeagueEntriesTableContext } from "./LeagueEntriesContext";

export default function MergeSourceUserBanner() {
  useNavigate();
  const mergeSourceUserUuid = useLeagueEntriesTableContext((state) => state.mergeSourceUserUuid);
  const setMergeSourceUserUuid = useLeagueEntriesTableContext(
    (state) => state.setMergeSourceUserUuid,
  );
  if (!mergeSourceUserUuid) {
    return null;
  }
  return (
    <Alert
      color="primary"
      variant="solid"
      sx={{ paddingX: 2, "--Alert-radius": 0 }}
      slotProps={{}}
      invertedColors
      endDecorator={
        <Button
          variant="solid"
          color="neutral"
          size="sm"
          onClick={() => setMergeSourceUserUuid(undefined)}
          sx={{ borderRadius: 4 }}
        >
          Cancel
        </Button>
      }
    >
      <Typography>Select another user to merge with...</Typography>
    </Alert>
  );
}
